import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
    Input,
    Row,
    Card,
    Form,
    Col,
    Divider,
    Spin,
    Typography,
    Select,
    DatePicker,
    InputNumber,
} from "antd";

import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import CustomButton from "../../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import {
    apiConfig,
    labelConfig,
    staticConfig,
} from "../../../../customer.config";
import styles from "../../../../../../assets/styles/styles";

const { Text, Title } = Typography;

function EditManageCurrentAcc(props) {
    //DECLARED VARIABLES
    const { userData } = props;
    const { session } = userData;
    const navigate = useNavigate();
    const [useForm] = Form.useForm();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [accountDetails, setAccountDetails] = useState({});

    useEffect(() => {
        getDetailById();
        localCurrency();
    }, []);

    const getDetailById = () => {
        const params = {
            associations: "all",
        };
        const url = `${apiConfig.savingsAccounts}/${state.id}`;

        let body = {
            session,
            params,
        };
        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
                setIsLoading(false);
            } else {
                const objDetail = res;
                setAccountDetails(objDetail);

                /**
                 * STOP LOADER
                 */
                setIsLoading(false);
            }
        });
    };

    const localCurrency = () => {
        const url = `${apiConfig.fxtransactions}/localcurrency`;

        let body = {
            session,
        };
        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                const objDetail = res;

                /**
                 * STOP LOADER
                 */
                setIsLoading(false);
            }
        });
    };

    const onChangeProduct = (productParam, value) => {
        console.log(value.value);
    };

    function onCancel() {
        navigate("/detail-current-account", { state: state });
    }

    const onSubmit = () => {
        console.log("Submission disabled because of the POST and PUT issue");
    };

    return (
        <MainLayout isEnableRightSidebar={true}>
            {/* PART 1  IMPORT TOP CONTENT*/}
            <TopContent pageTitle={labelConfig.editManageCurrentAcc} pageItems={staticConfig.editManageCurrentAccBreadcrumbItems} />
            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                >
                    <Form
                        initialValues={{
                            active: true,
                            isPenalty: false,
                        }}
                        form={useForm}
                        layout="vertical"
                        onFinish={onSubmit}
                    >
                        <Row>
                            <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                                {labelConfig.currentAccountSetup}
                            </Title>
                        </Row>
                        <Divider style={{ marginTop: 10, marginBottom: 30 }} />

                        <EditSection1 onChangeProduct={onChangeProduct} />
                        <EditSection2 onChangeProduct={onChangeProduct} />

                        <Row>
                            <Divider />
                            <CustomButton
                                content="Submit"
                                style={{
                                    width: "10%",
                                    marginLeft: "auto",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                htmlType="submit"
                                backgroundColor="#15CCAE"
                                colorText="black"
                                hoverBackground="#4FECA0"
                            />
                            <CustomButton
                                content="Cancel"
                                style={{
                                    width: "10%",
                                    marginLeft: "1%",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                backgroundColor="#fff"
                                colorText="black"
                                hoverBackground="#F5F5F5"
                                onClick={onCancel}
                            />
                        </Row>
                    </Form>
                </Card>
            </Spin>
        </MainLayout>
    );
};

export default EditManageCurrentAcc;

const EditSection1 = ({ onChangeProduct }) => {
    return (
        <Row>
            <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {labelConfig.generalInfo}
                </Title>
            </Divider>

            {/* DATEPICKER INPUT */}
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.datePastDue}
                    name="datePastDue"
                >
                    <DatePicker
                        disabledDate={BOM.DisabledAfterCurrentDate}
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.datePastDue,
                            "select"
                        )}
                        style={{ width: "100%", height: 35 }}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.daysPastDue}
                    name="daysPastDue"
                >
                    <InputNumber
                        style={styles.ofInputFieldNumber}
                        className="of-bold-disable-input"
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.ytdInterest
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.lastRate}
                    name="lastRateChangeDate"
                >
                    <DatePicker
                        disabledDate={BOM.DisabledAfterCurrentDate}
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.lastRate,
                            "select"
                        )}
                        style={{ width: "100%", height: 35 }}
                    />
                </Form.Item>
            </Col>

            {/* SELECT INPUT */}
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.nonPerforming}
                    name="nonPerforming"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.nonPerforming,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.transactionalAcc}
                    name="transactionalAccount"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.transactionalAcc,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.stressWithdrawal}
                    name="stressWithdrawal"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.stressWithdrawal,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>

            {/* NORMAL INPUT */}
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.finInterest}
                    name="finYtdInterestEarned"
                >
                    <InputNumber
                        style={styles.ofInputFieldNumber}
                        className="of-bold-disable-input"
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.finInterest)}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.ytdInterest}
                    name="ytdInterestEarned"
                >
                    <InputNumber
                        style={styles.ofInputFieldNumber}
                        className="of-bold-disable-input"
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.ytdInterest
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.contractReference}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.contractReference
                        )}
                    />
                </Form.Item>
            </Col>

            {/* SELECT INPUT */}
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.suspectedLaundering}
                    name="suspectedMoneyLaundering"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.suspectedLaundering,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.dsgInsured}
                    name="dsgInsuredAmount"
                >
                    <InputNumber style={styles.ofInputFieldNumber}

                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.dsgInsured
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.fraud}
                    name="fraud"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.fraud,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            {/* NORMAL INPUT */}
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.dsgUninsured}
                    name="dsgUninsuredAmount"
                >
                    <Input
                        className="of-bold-disable-input"
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.dsgUninsured)}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.legallyDisputed}
                    name="legallyDisputed"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.legallyDisputed,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.hedgingPortf}>
                    <Input
                        className="of-bold-disable-input"
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.hedgingPortf)}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.undocumentedAcc}
                    name="undocumentedAccount"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.undocumentedAcc,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.repoReference}>
                    <Input
                        className="of-bold-disable-input"
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.repoReference)}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.structuredDepositAcc}
                    name="structuredDepositAccount"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.structuredDepositAcc,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>

            {/* SELECT INPUT */}
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.universalSourceSys}
                    name="universalSourceSystem"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.universalSourceSys,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.operationalDeposit}
                    name="operationalDeposit"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.operationalDeposit,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>

        </Row>

    )
}
const EditSection2 = ({ onChangeProduct }) => {
    return (
        <Row>
            <Divider />
            {/* NORMAL INPUT */}
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.universalBranchId}>
                    <Input
                        className="of-bold-disable-input"
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.universalBranchId)}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.accountHolderInd}>
                    <Input
                        className="of-bold-disable-input"
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.accountHolderInd
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.accountStatusCode}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.accountStatusCode
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.extensionCode}>
                    <InputNumber
                        style={styles.ofInputFieldNumber}
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.extensionCode
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.jurisdiction}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.jurisdiction
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.bankRecovery}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.bankRecovery
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.transferableEligbleDep}>
                    <InputNumber
                        style={styles.ofInputFieldNumber}
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.transferableEligbleDep
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.sortCode}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.sortCode
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.iban}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.iban
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.extensionAccNo}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.extensionAccNo
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.swiftCode}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.swiftCode
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.achRoutingNo}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.achRoutingNo
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.wireRoutingNo}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.wireRoutingNo
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.bban}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.bban
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.upic}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.upic
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.bic}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.bic
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.facilityReference}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.facilityReference
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.portfolioType}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.portfolioType
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.debitInterestRate}
                    name="debitInterestRate"
                >
                    <InputNumber
                        style={styles.ofInputFieldNumber}
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.debitInterestRate
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.ifrsPortfolioType}>
                    <Input
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.ifrsPortfolioType
                        )}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.performingStatus}
                    name="performingStatus"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.performingStatus,
                            "select"
                        )}
                        options={[]}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.rateSpread}
                    name="rateSpread"
                >
                    <InputNumber
                        style={styles.ofInputFieldNumber}
                        className="of-bold-disable-input"

                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.rateSpread
                        )}
                    />
                </Form.Item>
            </Col>

            {/* DATEPICKER INPUT */}
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.dormantDate}
                    name="dormantDate"
                >
                    <DatePicker
                        disabledDate={BOM.DisabledAfterCurrentDate}
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.dormantDate,
                            "select"
                        )}
                        style={{ width: "100%", height: 35 }}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.dateOfPerformance}
                    name="perfStatusChangeDate"
                >
                    <DatePicker
                        disabledDate={BOM.DisabledAfterCurrentDate}
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.dateOfPerformance,
                            "select"
                        )}
                        style={{ width: "100%", height: 35 }}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.lastIntrstCapDate}
                    name="dateLastIntCap"
                >
                    <DatePicker
                        disabledDate={BOM.DisabledAfterCurrentDate}
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.lastIntrstCapDate,
                            "select"
                        )}
                        style={{ width: "100%", height: 35 }}
                    />
                </Form.Item>
            </Col>

            {/* SELECT INPUT */}
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.symmetricalInflow}
                    name="symmetricalInflowRate"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.symmetricalInflow,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.universalHqla}
                    name="universalHqla"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.universalHqla,
                            "select"
                        )}
                        options={staticConfig.universalHqlaData}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.clientMoneyPlaced}
                    name="clientMoneyPlaced"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.clientMoneyPlaced,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.typeOfBusinessActivity}
                    name="typeOfBusinessActivity"
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.instWhereTheClMnPlcd}
                    name="instWhereTheClMnPlcd"
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.typeOfClientAccForCass}
                    name="originalTerm"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.typeOfClientAccForCass,
                            "select"
                        )}
                        options={staticConfig.typeOfClientAccForCassData}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.clientAccAckLetter}
                    name="acknowledgementLetter"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.clientAccAckLetter,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.linkedToPeriodicRfRate}
                    name="linkedToPeriodicRfRate"
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.universalAccumImpAmnt}
                    name="accumulatedImpairmentAmount"
                >
                    <InputNumber
                        style={styles.ofInputFieldNumber}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.universalImpairmentStatus}
                    name="universalImpairmentStatus"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.universalImpairmentStatus,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.transcAccFlagBranchRt}
                    name="transactionalAccountBranchReturn"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.transcAccFlagBranchRt,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.overdrawnLimit}
                    name="overdrawnLimitAmount"
                >
                    <InputNumber
                        style={styles.ofInputFieldNumber}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.lastCstDrivenTransaction}
                    name="lastTransactionDate"
                >
                    <DatePicker
                        disabledDate={BOM.DisabledAfterCurrentDate}
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.lastCstDrivenTransaction,
                            "select"
                        )}
                        style={{ width: "100%", height: 35 }}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.universalGlMarker}>
                    <Input
                        className="of-bold-disable-input"
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.universalGlMarker)}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.beneficiary}
                    name="beneficiary"
                >
                    <Select
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? "").includes(
                                input?.toLowerCase()
                            )
                        }
                        placeholder={BOM.handlePlaceholderMsg(
                            labelConfig.beneficiary,
                            "select"
                        )}
                        options={staticConfig.yesOrNo}
                        showSearch
                        onChange={onChangeProduct}
                    />
                </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.localCurrencyCode}
                    name="accBalanceLocalCurrency"
                >
                    <InputNumber
                        style={styles.ofInputFieldNumber}
                        disabled
                    />
                </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                    label={labelConfig.accBalanceLocalCurrency}
                    name="accountBalanceLocalCurrency"
                >
                    <InputNumber
                        style={styles.ofInputFieldNumber}
                    />
                </Form.Item>
            </Col>
        </Row>
    )
}